import m from "../../geodata/es2015/vietnamLow";
window.am4geodata_vietnamLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/vietnamLow.js
// module id = null
// module chunks = 